import { render, staticRenderFns } from "./SpinLoader.vue?vue&type=template&id=3d0d7aa6&"
import script from "./SpinLoader.vue?vue&type=script&lang=js&"
export * from "./SpinLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports